import React from 'react';
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { WORKSPACE_NAV_GROUPS, type WorkspaceNavTab } from '../../domain/safetyCases/workspaceNavGroups';
import { WORKSPACE_TAB_LABELS } from '../../domain/safetyCases/safetyCasesWorkspacePresentationCopy';

export function WorkspaceNavGroups({
  value,
  onChange,
}: {
  value: WorkspaceNavTab | string;
  onChange: (event: React.SyntheticEvent, value: WorkspaceNavTab) => void;
}) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={1.5}
      alignItems={{ md: 'flex-end' }}
      data-testid="workspace-nav-groups"
      sx={{ borderBottom: 1, borderColor: 'divider', pb: 0.5 }}
    >
      {WORKSPACE_NAV_GROUPS.map((group) => (
        <Box key={group.id} sx={{ flex: 1, minWidth: 0 }} data-testid={`workspace-nav-group-${group.id}`}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontWeight: 800, letterSpacing: 0.08, textTransform: 'uppercase' }}
          >
            {group.label}
          </Typography>
          <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mb: 0.25 }}>
            {group.helper}
          </Typography>
          <Tabs
            value={(group.tabs as readonly string[]).includes(value) ? value : false}
            onChange={(event, next) => onChange(event, String(next) as WorkspaceNavTab)}
            aria-label={`${group.label} workspace tabs`}
          >
            {group.tabs.map((tab) => (
              <Tab
                key={tab}
                value={tab}
                label={WORKSPACE_TAB_LABELS[tab]}
                sx={{ textTransform: 'none', fontWeight: 700, minHeight: 40 }}
              />
            ))}
          </Tabs>
        </Box>
      ))}
    </Stack>
  );
}
